const en_master_price_tier = {
    "": "Price Tier",
    add: "Add Price Tier",
    edit: "Edit Price Tier",

    label: {
        name: "Price Tier Name"
    },

    error: {
        create: "Failed to create price tier",
        edit: "Failed to update price tier",
        delete: "Failed to delete price tier",
        name: "Price tier name is required",
    },

    success: {
        create: "Price tier created successfully",
        edit: "Price tier updated successfully",
        delete: "Price tier deleted successfully",
    },
}

export default en_master_price_tier;